import { render, staticRenderFns } from "./QuestionField.vue?vue&type=template&id=7fef97c9&scoped=true"
import script from "./QuestionField.vue?vue&type=script&lang=js"
export * from "./QuestionField.vue?vue&type=script&lang=js"
import style0 from "./QuestionField.vue?vue&type=style&index=0&id=7fef97c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef97c9",
  null
  
)

export default component.exports